import { SearchCarResolver } from './../../resolvers/search-car.resolver';
import { SharedModule } from './../../shared/shared.module';
import { MatSelectModule } from '@angular/material/select';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SearchCarComponent } from './search-car.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';


export const routes: Routes = [
  { 
    path: '', 
    component: SearchCarComponent, 
    pathMatch: 'full',
    resolve: {
      cars: SearchCarResolver
    }
  }
];

@NgModule({
  declarations: [SearchCarComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    SharedModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    FormsModule, 
    MatSelectModule,
    NgxSpinnerModule,
  ],
  exports: []
})
export class SearchCarModule { }